export class PrescriptionStatus {
    id: number;
    prescriptionStatusName: string;
    status: boolean;
}